import React from 'react';
import {
  FaCalendarCheck,
  FaPlaceOfWorship,
  FaCompass,
  FaGavel,
  FaMoneyBillWave,
  FaPhoneAlt,
  FaWhatsapp,
} from 'react-icons/fa';

const consultationServices = [
  {
    title: 'Garbhagriha Planning',
    icon: <FaPlaceOfWorship size={28} />,
    description: `We help you design the sacred Garbhagriha (sanctum sanctorum) based on Agama Shastra, ensuring spiritual alignment and traditional proportions.`,
  },
  {
    title: 'Vastu Compliance',
    icon: <FaCompass size={28} />,
    description: `Our consultations include in-depth Vastu analysis for site orientation, energy flow, and layout adjustments to ensure cosmic harmony.`,
  },
  {
    title: 'Idol Placement Guidance',
    icon: <FaGavel size={28} />,
    description: `We guide correct deity placement in your temple or shrine, adhering to Agamic prescriptions and traditional practices.`,
  },
  {
    title: 'Cost Estimation',
    icon: <FaMoneyBillWave size={28} />,
    description: `Receive a complete cost estimation based on your requirements — including materials, dimensions, sculpture, and site size.`,
  },
  {
    title: 'Book Free Consultation',
    icon: <FaCalendarCheck size={28} />,
    description: `Connect with Sthapathi Kalyanasundaram directly to discuss your temple plans. Online and in-person sessions available.`,
  },
];

const Consultation = () => {
  const royalBlue = '#002366';
  const background = '#f8faff';
  const darkText = '#2c2c2c';

  return (
    <section
      style={{
        minHeight: '100vh',
        width: '100%',
        padding: '40px 5vw',
        backgroundColor: background,
        fontFamily: 'Georgia, serif',
        color: darkText,
        boxSizing: 'border-box',
      }}
    >
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        {/* Title */}
        <h2
          style={{
            textAlign: 'center',
            color: royalBlue,
            fontSize: 'clamp(1.5rem, 4vw, 2rem)',
            marginBottom: '30px',
            fontWeight: 'bold',
          }}
        >
          Book Consultation with Sthapathi Kalyanasundaram
        </h2>

        {/* Intro Paragraph */}
        <p
          style={{
            textAlign: 'center',
            fontSize: 'clamp(1rem, 2.5vw, 1.1rem)',
            maxWidth: '800px',
            margin: '0 auto 40px auto',
            lineHeight: '1.8',
          }}
        >
          We offer detailed online and in-person consultations for temple planning and design.
          Whether you’re building a small shrine or a majestic temple, we guide you from layout to
          completion based on Agama Shastra and ancient tradition.
        </p>

        {/* Services Grid */}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: '40px',
          }}
        >
          {consultationServices.map((service, index) => (
            <div key={index} style={{ textAlign: 'justify' }}>
              <h3
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                  fontSize: '1.2rem',
                  color: royalBlue,
                  marginBottom: '12px',
                }}
              >
                {service.icon} {service.title}
              </h3>
              <p style={{ fontSize: '1.05rem', lineHeight: '1.8' }}>{service.description}</p>
            </div>
          ))}
        </div>

        {/* CTA Buttons */}
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            gap: '20px',
            marginTop: '50px',
          }}
        >
          {/* WhatsApp Button */}
          <a
            href="https://wa.me/919551566999?text=Hello%2C%20I%20would%20like%20to%20book%20a%20free%20consultation%20for%20temple%20design."
            target="_blank"
            rel="noopener noreferrer"
            style={{
              padding: '12px 24px',
              fontSize: '1rem',
              backgroundColor: '#25D366',
              color: '#fff',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              textDecoration: 'none',
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
            }}
          >
            <FaWhatsapp /> Chat on WhatsApp
          </a>

          {/* Call Button */}
          <a
            href="tel:+919551566999"
            style={{
              padding: '12px 24px',
              fontSize: '1rem',
              backgroundColor: royalBlue,
              color: '#fff',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              textDecoration: 'none',
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
            }}
          >
            <FaPhoneAlt /> Call Now
          </a>
        </div>
      </div>
    </section>
  );
};

export default Consultation;










